import React, { Component } from "react";
import {
  getNextFormNumberInGroup,
  submitForm,
  approveForm
} from "../../../../utils/api";
import {
  Row,
  Col,
  Button,
  Form,
  Input,
  Select,
  notification,
  message
} from "antd";
import BasicLayout from "../../../common/BasicLayout";
import SignaturePad from "react-signature-pad-wrapper";
import moment from "moment";
import _ from "lodash";
import styled from "styled-components";

const FormItem = Form.Item;
const Option = Select.Option;

const DivisionOptions = [
  "Adult Ed - Federal",
  "Adult Ed - State",
  "Adult Ed - TANF",
  "Adult Ed - El Civics",
  "Head Start",
  "CASE - 21 Century",
  "CASE - Partnership",
  "CASE - City of Houston",
  "CASE - Endowment",
  "Safe Schools - DOJ"
];

const CustomButton = styled(Button)`
  && {
    margin-top: 25px;
    color: #fff;
    border: none;
    background-color: ${props => props.bgcolor};
    display: block;
    width: 100%;
    white-space: normal;
    height: 50px;
    border-radius: 15px;

    :hover {
      background-color: ${props => props.bgcolor};
    }

    @media (min-width: 768px) {
      margin: 25px auto 0 auto;
      width: 75%;
    }

    @media (min-width: 992px) {
      margin: 25px auto 0 auto;
      width: 65%;
    }
  }
`;

const ProcedureListText = styled.p`
  margin: 0;
`;

const FormInput = styled(FormItem)`
  div input {
    border-radius: 15px;
    background: #dfe6e9;
    border: none;

    ::placeholder {
      color: rgba(0, 0, 0, 0.65);
    }
  }
`;

const FormInputFullName = styled(FormItem)`
  && {
    display: inline-block;
    width: 100%;
    margin: 0;
  }

  div input {
    border-radius: 15px;
    background: #dfe6e9;
    border: none;

    ::placeholder {
      color: rgba(0, 0, 0, 0.65);
    }
  }
`;

const FormSelect = styled(Select)`
  && {
    margin-bottom: 0px;
    font-family: "Montserrat", sans-serif !important;
    font-weight: 400 !important;

    div.ant-select-selection {
      border-radius: 15px;
      background: #dfe6e9;
      border: none;

      div.ant-select-selection__placeholder {
        color: rgba(0, 0, 0, 0.65);
      }
    }
  }
`;

const SignaturePadCol = styled(Col)`
  && {
    width: 100%;
    padding: 0px !important;
    margin: 0px auto 25px auto;
    box-shadow: rgba(0, 0, 0, 0.2) 0 20px 60px -10px;
    border-radius: 15px;

    @media (min-width: 768px) {
      width: 75%;
    }

    @media (min-width: 992px) {
      width: 65%;
    }
  }
`;

const ClearButton = styled(Button)`
  && {
    width: 100%;
    border-left: none;
    border-right: none;
    border-bottom: none;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;

    :active,
    :focus,
    :hover {
      border: none;
    }
  }
`;

class TimeAndEffortCertification extends Component {
  render() {
    const WrappedTimeAndEffortCertificationForm = Form.create()(
      TimeAndEffortCertificationForm
    );

    return (
      <BasicLayout>
        <Row style={{ textAlign: "center", margin: "25px 0 0 0" }}>
          <h1 style={{ margin: 0 }}>Federal Grant/Contract Salary Reporting</h1>
          <p>100% Time &amp; Effort Certification</p>
        </Row>
        <Row style={{ margin: "25px 0" }}>
          <h3 style={{ textDecoration: "underline" }}>PROCEDURE:</h3>
          <Row style={{ marginLeft: 25 }}>
            <ProcedureListText>
              A. Responsibility for timely completion of this form
            </ProcedureListText>
            <ProcedureListText>
              B. T &amp; E Certification must be completed following the close
              of each month by the last working day of each month
            </ProcedureListText>
            <ProcedureListText>
              C. T &amp; E reporting will be kept on file in the division along
              with grant/contract records
            </ProcedureListText>
            <ProcedureListText>
              D. Following completion of the grant period, T &amp; E records
              must be retained according to program specifications
            </ProcedureListText>
          </Row>
          <h3 style={{ textAlign: "center", margin: "25px 0" }}>
            By authority of 2 CFR 200, Subpart E, Cost Principles, the purpose
            of this Certification is to provide reasonable assurance that work
            performed is commensurate with salary charged to the grant/contract
            budget.
          </h3>
        </Row>
        <WrappedTimeAndEffortCertificationForm history={this.props.history} />
      </BasicLayout>
    );
  }
}

class TimeAndEffortCertificationForm extends Component {
  state = {
    isTitleDisabled: true,
    isManagerDisabled: true,
    titleOptions: [],
    managerOptions: []
  };

  getTitleOptionsByDivision = division => {
    switch (division) {
      case "Adult Ed - Federal":
      case "Adult Ed - State":
      case "Adult Ed - TANF":
      case "Adult Ed - El Civics":
      case "Safe Schools - DOJ":
        return ["Employee", "Director"];

      case "CASE - 21 Century":
      case "CASE - Partnership":
      case "CASE - City of Houston":
      case "CASE - Endowment":
        return ["Employee", "Assistant Director", "Director"];

      case "Head Start":
        return [
          "Employee",
          "Operations Manager",
          "Nutrition Manager",
          "Health & Family Manager",
          "Ed & Special Service Manager",
          "Center Manager",
          "Community Partnerships Manager",
          "Compliance Manager",
          "Assistant Director of Operations",
          "Assistant Director of Childcare Partnerships",
          "Head Start Senior Director"
        ];
    }
  };

  getManagerOptionsByTitle = title => {
    const { getFieldValue } = this.props.form;
    let options = [];

    switch (title) {
      case "Employee":
        switch (getFieldValue("Division")) {
          case "Adult Ed - Federal":
          case "Head Start":
          case "CASE - 21 Century":
          case "Safe Schools - DOJ":
            options.push("Manager 1");
            break;

          case "Adult Ed - State":
          case "CASE - Partnership":
            options.push("Manager 2");
            break;

          case "Adult Ed - TANF":
          case "CASE - City of Houston":
            options.push("Manager 3");
            break;

          case "Adult Ed - El Civics":
          case "CASE - Endowment":
            options.push("Manager 4");
            break;
        }
        break;

      case "Operations Manager":
      case "Nutrition Manager":
      case "Health & Family Manager":
      case "Ed & Special Service Manager":
      case "Center Manager":
      case "Community Partnerships Manager":
      case "Compliance Manager":
      case "Assistant Director of Operations":
      case "Assistant Director of Childcare Partnerships":
      case "Assistant Director":
      case "Director":
      case "Head Start Senior Director":
        break;
    }

    return options;
  };

  handleSelect = value => {
    getNextFormNumberInGroup(value).then(res => {
      this.props.form.setFieldsValue({
        formNumber: "Form Number: #" + res.data.message
      });
    });
  };

  handleDivisionChange = value => {
    const { getFieldValue, resetFields } = this.props.form;

    this.setState({
      isTitleDisabled: false,
      titleOptions: this.getTitleOptionsByDivision(value),
      managerOptions: []
    });

    if (getFieldValue("Division")) {
      if (getFieldValue("Division") !== value) {
        resetFields(["Title/Position", "Manager"]);
      }
    }
  };

  handleTitleChange = value => {
    const { getFieldValue, setFieldsValue, resetFields } = this.props.form;
    const isNotEmployee = title => {
      switch (title) {
        case "Operations Manager":
        case "Nutrition Manager":
        case "Health & Family Manager":
        case "Ed & Special Service Manager":
        case "Center Manager":
        case "Community Partnerships Manager":
        case "Compliance Manager":
        case "Assistant Director of Operations":
        case "Assistant Director of Childcare Partnerships":
        case "Assistant Director":
        case "Director":
        case "Head Start Senior Director":
          return true;

        default:
          return false;
      }
    };

    this.setState({
      isManagerDisabled: isNotEmployee(value),
      managerOptions: this.getManagerOptionsByTitle(value)
    });

    if (getFieldValue("Title/Position") || value) {
      if (getFieldValue("Title/Position") !== value) {
        if (isNotEmployee(value)) {
          // prettier-ignore
          setFieldsValue({
            "Manager": "No manager needed"
          });
        } else {
          resetFields(["Manager"]);
        }
      }
    }
  };

  handleSubmit = e => {
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (this.signaturePad.isEmpty()) {
          message.error("You must provide your signature");
        } else {
          let d = new moment();
          let formNumber = "";
          let formRequest = {
            formName: "Time And Effort Certification",
            formSubmissionTimeStamp: moment(d).format("MMMM-DD-YYYY HH:mm:ss"),
            data: [],
            files: []
          };
          const division = values["Division"]
            .split(" ")
            .join("_")
            .replace(/[^a-zA-Z_]/, "")
            .replace(/__/, "_")
            .toLowerCase();
          const title = values["Title/Position"]
            .replace(/[^a-zA-Z0-9]/g, "_")
            .replace("of", "_")
            .replace("__", "")
            .toLowerCase();
          const submittedBy = `${division}_${title}`;
          const name = `${values["Full Name"]}`;

          const approvalRequest = Object.assign(
            {},
            {
              name: name,
              approvingAuthority: submittedBy,
              decision: "Submitted",
              date: moment(d).format("MMMM-DD-YYYY HH:mm:ss")
            }
          );

          formRequest.files.push(
            Object.assign(
              {},
              {
                fileName: `${values["Title/Position"]
                  .split(" ")
                  .join("_")
                  .toUpperCase()}_SIGNATURE.png`,
                fileType: "image/png",
                data: this.signaturePad.toDataURL("image/png")
              }
            )
          );

          for (const [key, value] of Object.entries(values)) {
            if (key === "formNumber") {
              formNumber = value.split("#")[1];
              formRequest.formNumber = value.split("#")[1];
            } else {
              formRequest.data.push(
                Object.assign(
                  {},
                  {
                    formQuestion: key,
                    formAnswer: value
                  }
                )
              );
            }
          }

          submitForm(formRequest)
            .then(response => {
              approveForm(formNumber, approvalRequest)
                .then(res => {
                  console.log(res);
                })
                .catch(err => {
                  console.log(err);
                });

              this.props.history.push("/federal-grant-contract-salary");

              notification.success({
                message: "Form Submission",
                description: `Your form has been successfully submitted! Your Form Number is ${formNumber}`,
                duration: 0
              });
            })
            .catch(err => {
              console.log(err);
            });
        }
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const {
      isTitleDisabled,
      isManagerDisabled,
      titleOptions,
      managerOptions
    } = this.state;

    return (
      <div>
        <Form onSubmit={this.handleSubmit}>
          <Row gutter={8}>
            <Col xs={24} md={12}>
              <FormInput>
                {getFieldDecorator("formNumber")(
                  <Input placeholder={"Form Number: #"} disabled />
                )}
              </FormInput>
            </Col>
            <Col xs={24} md={12}>
              <FormInput>
                {getFieldDecorator("NOGA ID", {
                  rules: [
                    { required: true, message: "Please fill out this field" }
                  ]
                })(
                  <FormSelect placeholder="Select the NOGA ID #">
                    <Option value="212-19">212-19</Option>
                  </FormSelect>
                )}
              </FormInput>
            </Col>
            <Col xs={24} md={12}>
              <FormInput>
                {getFieldDecorator("Division", {
                  rules: [
                    { required: true, message: "Please fill out this field" }
                  ]
                })(
                  <FormSelect
                    placeholder="Select your division"
                    onChange={this.handleDivisionChange}
                  >
                    {DivisionOptions.map(div => (
                      <Option key={div}>{div}</Option>
                    ))}
                  </FormSelect>
                )}
              </FormInput>
            </Col>
            <Col xs={24} md={12}>
              <FormInput>
                {getFieldDecorator("Title/Position", {
                  rules: [
                    { required: true, message: "Please fill out this field" }
                  ]
                })(
                  <FormSelect
                    placeholder="Select your title"
                    onChange={this.handleTitleChange}
                    disabled={isTitleDisabled}
                  >
                    {titleOptions.map(option => (
                      <Option key={option}>{option}</Option>
                    ))}
                  </FormSelect>
                )}
              </FormInput>
            </Col>
            <Col xs={24} md={12}>
              <FormInput>
                {getFieldDecorator("Manager", {
                  rules: [
                    {
                      required: !isManagerDisabled,
                      message: "Please fill out this field"
                    }
                  ]
                })(
                  <FormSelect
                    placeholder="Select your manager"
                    disabled={isManagerDisabled}
                  >
                    {managerOptions.map(option => (
                      <Option key={option}>{option}</Option>
                    ))}
                  </FormSelect>
                )}
              </FormInput>
            </Col>
            <Col xs={24} md={12}>
              <FormInput>
                {getFieldDecorator("Employee Number", {
                  rules: [
                    { required: true, message: "Please fill out this field" }
                  ]
                })(<Input placeholder="Enter your employee number" />)}
              </FormInput>
            </Col>
            <Col xs={24}>
              <FormInput>
                {getFieldDecorator("Grant Award Period", {
                  rules: [
                    { required: true, message: "Please fill out this field" }
                  ]
                })(
                  <FormSelect
                    placeholder="Select the Grant Award Period"
                    onSelect={this.handleSelect}
                  >
                    <Option value="FY 18-19">FY 18-19</Option>
                    <Option value="FY 19-20">FY 19-20</Option>
                    <Option value="FY 20-21">FY 20-21</Option>
                    <Option value="FY 21-22">FY 21-22</Option>
                    <Option value="FY 22-23">FY 22-23</Option>
                  </FormSelect>
                )}
              </FormInput>
            </Col>
            {/* <Col xs={24} md={12}>
              <FormInput>
                {getFieldDecorator("Federal Award Grant Title", {
                  rules: [
                    { required: true, message: "Please fill out this field" }
                  ]
                })(<Input placeholder="Enter the Federal Award Grant Title" />)}
              </FormInput>
            </Col> */}
            <h3 style={{ textAlign: "center" }}>EMPLOYEE STATEMENT:</h3>
            <Row style={{ textAlign: "center", marginBottom: 25 }}>
              <Col span={1}>
                <span style={{ position: "relative", top: "10px" }}>I, </span>
              </Col>
              <Col span={23}>
                <FormInputFullName>
                  {getFieldDecorator("Full Name", {
                    rules: [
                      { required: true, message: "Please fill out this field" }
                    ]
                  })(<Input placeholder="Enter your full name" />)}
                </FormInputFullName>
              </Col>
              <span>
                {" "}
                understand and certify that 100% of my duties and
                responsibilities are performed for the Adult Ed Grants as
                allocated by adult education classes
              </span>
            </Row>
            <p style={{ textAlign: "center", fontStyle: "italic", margin: 0 }}>
              Sign below
            </p>
            <SignaturePadCol>
              <SignaturePad ref={ref => (this.signaturePad = ref)} />
              <ClearButton onClick={() => this.signaturePad.clear()}>
                Clear
              </ClearButton>
            </SignaturePadCol>
            <CustomButton
              htmlType="submit"
              bgcolor="#0984e3"
              size="large"
              type="primary"
            >
              Submit
            </CustomButton>
          </Row>
        </Form>
      </div>
    );
  }
}

export default TimeAndEffortCertification;
